import React from "react";
import { makeStyles } from "@material-ui/styles";
import { AutoSizer } from "react-virtualized";
import MapPanZoomWrapper from "./MapPanZoomWrapper";

const useStyles = makeStyles((theme) => ({
  svg: {
    width: "100vw",
    height: window.innerHeight,
  },
  wrapper: {
    width: "100vw",
    height: window.innerHeight,
  },
  tools: {
    position: "absolute",
    top: "0",
    zIndex: "999",
  },
  actionHeader: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(2),
  },
  margin: {
    marginRight: theme.spacing(1),
  },
}));

export default function MapInterface() {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <AutoSizer>
        {({ width, height }) =>
          width === 0 || height === 0 ? null : (
            <MapPanZoomWrapper width={width} height={height} />
          )
        }
      </AutoSizer>
    </div>
  );
}
